module.exports = __webpack_public_path__ + "PatinEB04.png?7f94d2b2b98e6613b3e85a18df370340";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PatinEB04.png
// module id = 2622
// module chunks = 0